export const AO_SEND_ADDRESS_DETAILS_REQUEST = 'AO_SEND_ADDRESS_DETAILS_REQUEST';
export const AO_SEND_ADDRESS_DETAILS_SUCCESS = 'AO_SEND_ADDRESS_DETAILS_SUCCESS';
export const AO_SEND_ADDRESS_DETAILS_FAILURE = 'AO_SEND_ADDRESS_DETAILS_FAILURE';
export const AO_ORIGIN_ADDRESS_DETAILS_REQUEST = 'AO_ORIGIN_ADDRESS_DETAILS_REQUEST';
export const AO_ORIGIN_ADDRESS_DETAILS_SUCCESS = 'AO_ORIGIN_ADDRESS_DETAILS_SUCCESS';
export const AO_ORIGIN_ADDRESS_DETAILS_FAILURE = 'AO_ORIGIN_ADDRESS_DETAILS_FAILURE';
export const AO_RETURN_ADDRESS_DETAILS_REQUEST = 'AO_RETURN_ADDRESS_DETAILS_REQUEST';
export const AO_RETURN_ADDRESS_DETAILS_SUCCESS = 'AO_RETURN_ADDRESS_DETAILS_SUCCESS';
export const AO_RETURN_ADDRESS_DETAILS_FAILURE = 'AO_RETURN_ADDRESS_DETAILS_FAILURE';
// Destination address actions
export const sendAddOrderAddressDetailsSuccess = (payload) => ({
    type: AO_SEND_ADDRESS_DETAILS_SUCCESS,
    payload,
});
export const sendAddOrderAddressDetailsRequest = (payload) => ({
    type: AO_SEND_ADDRESS_DETAILS_REQUEST,
    payload,
});
export const sendAddOrderAddressDetailsFailure = (payload) => ({
    type: AO_SEND_ADDRESS_DETAILS_FAILURE,
    payload,
});
// Origin address actions
export const AOoriginAddressDetailsSuccess = (payload) => ({
    type: AO_ORIGIN_ADDRESS_DETAILS_SUCCESS,
    payload,
});
export const AOoriginAddressDetailsRequest = (payload) => ({
    type: AO_ORIGIN_ADDRESS_DETAILS_REQUEST,
    payload,
});
export const AOoriginAddressDetailsFailure = (payload) => ({
    type: AO_ORIGIN_ADDRESS_DETAILS_FAILURE,
    payload,
});
// Return address actions
export const AOreturnAddressDetailsSuccess = (payload) => ({
    type: AO_RETURN_ADDRESS_DETAILS_SUCCESS,
    payload,
});
export const AOreturnAddressDetailsRequest = (payload) => ({
    type: AO_RETURN_ADDRESS_DETAILS_REQUEST,
    payload,
});
export const AOreturnAddressDetailsFailure = (payload) => ({
    type: AO_RETURN_ADDRESS_DETAILS_FAILURE,
    payload,
});
